export class SurveyQuestion {
    constructor(_data) {
        this.id = _data.id || 0;
        this.title = _data.title || '';
        this.description = _data.description || '';
        this.type = _data.type || '';
        this.options = _data.options || {};
        this.required = _data.required || false;
        this.max_rating = _data.max_rating || 0;
        this.choices = _data.choices || [];
        this.tags = _data.tags || [];
        this.deleted = _data.deleted || false;
    }
}
